import { render, staticRenderFns } from "./remoteHistory.vue?vue&type=template&id=58e7298e&scoped=true&"
import script from "./remoteHistory.vue?vue&type=script&lang=js&"
export * from "./remoteHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7298e",
  null
  
)

export default component.exports